export const AUTH_PATHS = {
  root: 'auth',
  login: 'login',
  logout: 'logout',
};

export const PRIVATE_PATHS = {
  studio: 'studio',
  files: 'files',
  projects: 'projects',
  providers: 'providers',
  skills: 'skills',
  admin: 'admin',
  director: 'director',
};
